import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import TopMenu from "../TopMenu";
import TableDocument from "../TableDocument";
import FilterModal from "../../../Components/Common/FilterModal";
import { get } from "../../../utils/api";
import { useUser } from "../../../context/AuthContext";
import ApprovalSidebar from "../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../Components/Masters/MessagePopup";

const defaultViewheaders = [{ key: "requestStatus", title: "Status" }];

const Scope3ApprovalListCore = ({
  pageTitle,
  apiSegment,
  ViewPage,
  headings,
  viewheaders = defaultViewheaders,
  columnWidth: columnWidthProp,
  mapRow = (row) => row,
}) => {
  const { user } = useUser();
  const approvalUrl = `/scope3/${apiSegment}/apporveOrReject`;

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {},
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        facilityList: selectedFacility.join(","),
        page,
        limit: 10,
      }).toString();

      const response = await get(
        `/scope3/${apiSegment}/apporevelist?${queryParams}`,
      );
      const rows = response?.data?.data || [];
      setData(rows.map(mapRow));
      setTotalPages(response?.data?.totalPages ?? 1);
      setPage(response?.data?.currentPage ?? page);
    } catch (error) {
      console.error(`Scope3 approval list (${apiSegment}):`, error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchDataCallback = async () => {
    await fetchData();
  };

  const toggleData = [];
  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
  ];

  const columnWidth =
    columnWidthProp ||
    (user?.companyAdmin
      ? "12% 13% 12.5% 13% 12.5% 12.5% 12.5% 9%"
      : "12% 20% 13% 15% 15% 12.5% 12.5%");

  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
        }}
        heading={pageTitle}
      />
      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={headings}
        columnWidth={columnWidth}
        setsnackOpen={setsnackOpen}
        fetchDataCallback={fetchDataCallback}
        apiUrl={approvalUrl}
        viewheaders={viewheaders}
        viewPage={ViewPage}
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
    </MainDashboardLayout>
  );
};

export default Scope3ApprovalListCore;
